import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export const Offer = () => {
  const [slides, setSlides] = useState([]);
  const getData = () => {
    axios
      .get("/page-section/public/shows?sectionType=banner")
      .then((res) => {
        const slidesData = res.data.data;
        setSlides(slidesData);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="container-fluid pt-5 pb-3">
      <div className="row px-xl-5">
        <div className="col-md-6">
          <div className="product-offer mb-30 image-offer">
            <Link to={slides[0]?.content[0]?.link || "#"}>
              <img
                className="img-fluid"
                src={slides[0]?.content[0]?.imageUrl}
                alt={slides[0]?.content[0]?.title || "Offer 1"}
              />
            </Link>
          </div>
        </div>
        <div className="col-md-6">
          <div className="product-offer mb-30 image-offer">
            <Link to={slides[1]?.content[0]?.link || "#"}>
              <img
                className="img-fluid"
                src={slides[1]?.content[0]?.imageUrl}
                alt={slides[1]?.content[0]?.title || "Offer 2"}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
